import React from 'react';

const ModalTitle = props => {
  return <h2 className="mt-n1 mb-3 pb-1 border-bottom">{props.children}</h2>;
};

export default ModalTitle;
